import { ProductSegment, ProductSegmentMetric } from '@zonofi/zono-money-store';
import React from 'react';
import { ExpandableMenu, ExpandableMenuItem, TagChip } from '../../components';
import './product-segments.scss';

const SegmentsDisplayMap: Record<ProductSegmentMetric, string> = {
  [ProductSegmentMetric.NON_MOVING]: '⏸️ Non Moving',
  [ProductSegmentMetric.NEW_LAUNCH]: '🚀 New Launch',
  [ProductSegmentMetric.SLOW_MOVING]: '😴 Slow Moving',
  [ProductSegmentMetric.FAST_MOVING]: '⚡ Fast Moving',
  [ProductSegmentMetric.TOP_GROSSING]: '🏆 Top Grossing',
};

function getSegmentClassName(segment: ProductSegmentMetric): string {
  return (
    'segment-' +
    segment
      .toLowerCase() // "Non Moving" → "non moving"
      .replace(/\s+/g, '-') // spaces → "-"
      .replace(/[^a-z0-9-]/g, '') // remove unsafe characters if any
  );
}

interface ProductSegmentsProps {
  segments: ProductSegment[];
}

export const ProductSegments: React.FC<ProductSegmentsProps> = ({
  segments,
}) => {
  if (!segments.length) return null;
  const firstSegment = segments[0];
  const additionalSegments = segments.slice(1);

  const mainContent = (
    <div className="visible-segments">
      <TagChip
        key={firstSegment.segmentId}
        tagName={SegmentsDisplayMap[firstSegment.segmentName]}
        needTagIcon={false}
        containerClass={getSegmentClassName(firstSegment.segmentName)}
        textClass={'segment-tag-text font-regular'}
      />
    </div>
  );

  const additionalItems: ExpandableMenuItem[] = additionalSegments.map(
    (segment) => {
      return {
        id: segment.segmentId,
        content: (
          <TagChip
            tagName={SegmentsDisplayMap[segment.segmentName]}
            needTagIcon={false}
            containerClass={getSegmentClassName(segment.segmentName)}
            textClass={'segment-tag-text font-regular'}
          />
        ),
      };
    }
  );

  return (
    <ExpandableMenu
      mainContent={mainContent}
      additionalItems={additionalItems}
      triggerComponent={(count, onToggle) => (
        <div onClick={onToggle}>
          <TagChip tagName={`+${count}`} needTagIcon={false} variant="gray" />
        </div>
      )}
      className="product-segments"
      popupClassName="segment-tags-popup"
      popupItemClassName="segment-popup-item"
    />
  );
};
